var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorKudzuplus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FF7468"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 6.03749L11.2 10.2375L8.79995 10.2375L8.79995 6.03749L11.2 6.03749Z",
    fill: "#262B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4375C9.17157 11.4375 8.5 12.1091 8.5 12.9375C8.5 13.7659 9.17157 14.4375 10 14.4375C10.8284 14.4375 11.5 13.7659 11.5 12.9375C11.5 12.1091 10.8284 11.4375 10 11.4375Z",
    fill: "#262B3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 6.03749L11.2 10.2375L8.79995 10.2375L8.79995 6.03749L11.2 6.03749Z",
    fill: "#324261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4375C9.17157 11.4375 8.5 12.1091 8.5 12.9375C8.5 13.7659 9.17157 14.4375 10 14.4375C10.8284 14.4375 11.5 13.7659 11.5 12.9375C11.5 12.1091 10.8284 11.4375 10 11.4375Z",
    fill: "#324261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorKudzuplus);
export default __webpack_public_path__ + "static/media/Error_kudzuplus.45bd2952c480c0a710e2a5a0906a61a7.svg";
export { ForwardRef as ReactComponent };